
import { ErrorViewModel } from './ErrorViewModel';

export class HttpRequestError extends ErrorViewModel {

  constructor(public readonly errCode: string,
              public readonly serverMsg: string,
              public readonly httpCode: number,
              public readonly requestError?: any) {

                super(errCode, serverMsg);
  }
}
